/* Kalles 5.2.1: auto-load the visible collection tab using its existing loader. */
(() => {
  if (window.cascadesTabsScroll || !('IntersectionObserver' in window)) return;
  window.cascadesTabsScroll = true;
  const selector = '.hdt-tab-item wrapp-hdt-lm-url a[append][section-id]';
  const observed = new Set();
  const attempted = new WeakSet();
  const pending = new Map();
  function visible(link) {
    const tab = link.closest('.hdt-tab-item');
    return !!tab?.hasAttribute('tab-selected') && !tab.hidden && link.getClientRects().length > 0;
  }
  function release(link) {
    const task = pending.get(link);
    if (!task) return;
    clearTimeout(task.timer);
    link.removeAttribute('aria-busy');
    pending.delete(link);
  }
  function load(link) {
    const footer = link.closest('[loadmore-btn-wrapp]');
    if (!link.isConnected || !visible(link) || attempted.has(link) || !footer || footer.hasAttribute('loading')) return;
    const wrapper = link.closest('wrapp-hdt-lm-url');
    if (!customElements.get('wrapp-hdt-lm-url')) return;
    // Never follow a plain link before Kalles upgrades and attaches its click handler.
    if (!(wrapper instanceof customElements.get('wrapp-hdt-lm-url'))) return;
    attempted.add(link);
    link.setAttribute('aria-busy', 'true');
    const timer = setTimeout(() => {
      // Kalles leaves its loading state in place on a failed fetch. Restore manual retry.
      if (link.isConnected && footer.hasAttribute('loading')) {
        wrapper.abortController2?.abort();
        footer.removeAttribute('loading');
      }
      release(link);
    }, 20000);
    pending.set(link, { timer });
    link.click();
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) load(entry.target);
  }, { rootMargin: '0px 0px 180px 0px', threshold: 0 });
  function scan(reset = false) {
    for (const link of observed) if (!link.isConnected) {
      observer.unobserve(link);
      observed.delete(link);
      release(link);
    }
    for (const link of document.querySelectorAll(selector)) {
      if (!observed.has(link) || reset) {
        observer.unobserve(link);
        observer.observe(link);
        observed.add(link);
      }
    }
  }
  let queued = false;
  let resetNeeded = false;
  const changes = new MutationObserver(records => {
    resetNeeded ||= records.some(record => record.type === 'attributes');
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan(resetNeeded);
      resetNeeded = false;
    });
  });
  function start() {
    changes.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['tab-selected', 'hidden'] });
    scan();
    customElements.whenDefined('wrapp-hdt-lm-url').then(() => scan(true));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
